<template>
  <div class="flex flex-col bg-hint divide-y user-profile-mobile">
    <div class="flex flex-row items-center justify-between py-6 px-8">
      <b class="text-18px leading-22px">{{ $delve(payload, 'name') }}</b>
      <ul class="flex flex-row items-center space-x-6 text-12px leading-22px">
        <div class="li flex flex-row items-center space-x-2">
          <span class="text-muted">ID пользователя:</span>
          <b>{{ $delve(payload, 'id') }}</b>
        </div>
        <div class="li flex flex-row items-center space-x-2">
          <span class="text-muted">Дата регистрации:</span>
          <b>{{ moment($delve(payload, 'createdAt')).format('DD.MM.YYYY') }}</b>
        </div>
        <div
          class="li flex flex-row items-center space-x-1"
          v-if="$delve(payload, 'rating') !== null && typeof $delve(payload, 'rating') !== 'undefined'">
          <img class="mb-1" src="@/assets/icons/star.svg"/>
          <b class="text-16px leading-16px">{{ $delve(payload, 'rating') }}</b>
        </div>
      </ul>
    </div>
    <slot v-if="$slots.subheader" name="subheader" />
    <div class="flex flex-row items-center pt-6 px-8">
      <ul class="flex flex-row items-center flex-wrap text-14px leading-16px">
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="$delve(payload, 'legalInfo')">
          <span class="text-14px leading-16px text-muted">Тип:</span>
          <b>{{ $delve(payload, 'businessType.label') }}</b>
        </li>
        <li class="flex flex-row items-center space-x-2 mr-10 mb-6">
          <span class="text-14px leading-16px text-muted">Телефон:</span>
          <b>{{ $delve(payload, 'phone') }}</b>
          <OpenDialogsProButton :phone="$delve(payload, 'phone')" />
        </li>
        <li v-if="payload" class="flex flex-row items-center space-x-2 mr-10 mb-6">
          <span class="text-14px leading-16px text-muted">Дата регистрации:</span>
          <template v-if="payload.createdAt">
            <b>{{ moment(payload.createdAt).format('DD.MM.YYYY') }}</b>
          </template>
          <template v-if="payload.registrationDate">
            <b>{{ moment(payload.registrationDate).format('DD.MM.YYYY') }}</b>
          </template>
        </li>
        <li class="flex flex-row items-center space-x-2 mr-10 mb-6">
          <span class="text-14px leading-16px text-muted">Email:</span>
          <b>{{ $delve(payload, 'email') }}</b>
          <img
            v-if="$delve(payload, 'emailVerified') || $delve(payload, 'email_verified')"
            class="w-3"
            src="@/assets/icons/ok.svg"
            alt="">
        </li>
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="$delve(payload, 'region.country.name')">
          <span class="text-14px leading-16px text-muted">Страна:</span>
          <b>{{ $delve(payload, 'region.country.name') }}</b>
        </li>
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="$delve(payload, 'region.name')">
          <span class="text-14px leading-16px text-muted">Регион:</span>
          <b>{{ $delve(payload, 'region.name') }}</b>
        </li>
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="showContractorLocationFields">
          <span class="text-14px leading-16px text-muted">Город:</span>
          <b>{{ $delve(payload, 'city') || '—' }}</b>
        </li>
        <li
          class="flex flex-row items-start space-x-2 mr-10 mb-6 w-full"
          v-if="showRegistrationComment">
          <span class="text-14px leading-16px text-muted flex-shrink-0">Комментарий регистрации:</span>
          <b class="whitespace-pre-line">{{ $delve(payload, 'registrationComment') || '—' }}</b>
        </li>
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="typeof $delve(payload, 'passportFilled') !== 'undefined'">
          <span class="text-14px leading-16px text-muted">Паспорт:</span>
          <b>{{ $delve(payload, 'passportFilled') ? 'заполнено' : 'не заполнено' }}</b>
        </li>
        <li
          class="flex flex-row items-center space-x-2 mr-10 mb-6"
          v-if="typeof $delve(payload, 'cardAdded') !== 'undefined'">
          <span class="text-14px leading-16px text-muted">Карта:</span>
          <b>{{ $delve(payload, 'cardAdded') ? 'указана' : 'не указана' }}</b>
        </li>
      </ul>
    </div>
    <div class="grid-x flex flex-row items-stretch py-10 px-8 space-x-12">
      <div
        class="flex flex-col bg-white p-5 rounded-lg w-48 justify-between"
        v-for="(pin, index) in pins"
        :key="index">
        <b class="text-28px leading-32px mb-5">
          {{ pin.data }}
        </b>
        <span class="span text-muted">{{ pin.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import OpenDialogsProButton from '@/components/OpenDialogsProButton.vue';

export default {
  components: { OpenDialogsProButton },
  props: {
    payload: {
      required: true,
      validator: (obj) => typeof obj === 'object' || obj === null,
    },
    pins: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  computed: {
    showContractorLocationFields() {
      return !!(
        this.$delve(this.payload, 'legalInfo')
        || this.$delve(this.payload, 'city')
        || this.$delve(this.payload, 'cityId')
        || this.$delve(this.payload, 'registrationComment')
      );
    },
    showRegistrationComment() {
      return !!(
        this.$delve(this.payload, 'registrationComment')
        || this.$delve(this.payload, 'legalInfo')
      );
    },
  },
  methods: {
    moment(data, format) {
      return moment(data, format);
    },
  },
};
</script>
